var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo-div"},[_c('span',{staticClass:"logo-title-name",class:{ pgray: !_vm.nightMode, 'text-light': _vm.nightMode }},[_vm._v(_vm._s(_vm.name))]),_c('span',{staticClass:"logo-title-dot pblue"},[_vm._v(_vm._s(_vm.dot))])])}
var staticRenderFns = []

export { render, staticRenderFns }